import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function UnPaidOperator() {
  const [finalBillAmount, setFinalBillAmount] = useState(0);
  const [monthBillStatus, setMonthBillStatus] = useState("");
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  // ✅ Get cookie safely
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [key, value] = cookie.split("=");
      if (key === name) return value;
    }
    return null;
  }

  const user = getCookie("user");

  // ✅ Redirect if no session
  useEffect(() => {
    if (!user) {
      navigate("/login");
    } else {
      fetchMonthBill();
    }
  }, []);

  // ✅ Fetch bill amount
  async function fetchMonthBill() {
    try {
      const response = await axios.post("https://node.cabletvpay.in/monthbill", {
        user,
      });

      if (response.status === 200 && response.data.status) {
        setFinalBillAmount(response.data.data.final_payable_amount || 0);
        setMonthBillStatus(response.data.data.bill_status || "");
      }
    } catch (error) {
      console.error("Error fetching final bill:", error);
      toast.error("Failed to fetch final bill amount");
    } finally {
      setLoading(false);
    }
  }

  // ✅ Loading UI
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <h4>Loading...</h4>
      </div>
    );
  }

    return (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-light w-100">
            <div
                className="card shadow-lg w-auto elevation-3"
                style={{
                  
                    borderRadius: '1.5rem',
                    border: 'none',
                    animation: 'fadeIn 0.6s ease-in-out',
                    boxShadow: '0 0 30px rgba(0, 0, 0, 0.1)',
                }}
            >
                <div
                    className="card-header text-center text-white w-auto"
                    style={{
                        background: 'linear-gradient(90deg, #f44336, #e57373)',
                        borderTopLeftRadius: '1.5rem',
                        borderTopRightRadius: '1.5rem',
                        padding: '1.5rem 1rem',
                    }}
                    
                >
                  
                  <h2 className="fw-bold mb-0">⚠️ Session Expired  Due to Pending Bill Payment</h2> 
                </div>

                <div className="card-body text-center px-4 py-5">
                    <span className="badge bg-warning text-dark mb-3 px-3 py-2 fs-6 rounded-pill">
                        Payment Required
                    </span>

                    <h5 className="text-secondary fw-semibold mb-3">
                        Please pay your outstanding bill to continue access.
                    </h5>

                    <h4 className="text-primary fw-bold mb-4">
                        Bill Amount: ₹ <span className="text-dark">{finalBillAmount}</span>
                    </h4>

                   

                    <p className="text-info fs-5 mb-4">
                        📞 <strong>+91 81241 24555</strong>
                    </p>

                    <a
                        href="#"
                        className="btn btn-outline-info btn-lg px-5 py-2 rounded-pill shadow-sm d-inline-flex align-items-center gap-2"
                        style={{ transition: '0.3s all' }}
                    >
                        <i className="bi bi-google"></i> GPay No: 81241 24555
                    </a>
                </div>
            </div>

            {/* Animation + Bootstrap Icons CDN */}
            <style>{`
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
           
        </div>
    );
}

export default UnPaidOperator;
